<template>
  <div>
    <button
      class="rating-dtv-stv"
      type="button"
      :aria-label="$t(`object:${method}Stars.${method}Header`)"
      :title="$t(`object:${method}Stars.${method}Header`)"
      @click="show"
    >
      <template v-if="method === 'DTV'">
        <i class="icon-size logo logo-dtv">
          <icon-dtv-logo-small />
        </i>
        <i
          v-for="item in numStars"
          :key="'dtvStar' + item"
          class="icon-v icon-dtv-star"
        >
          <icon-dtv-star />
        </i>
      </template>
      <template v-else-if="method === 'STV'">
        <i class="icon-size logo logo-stv">
          <icon-stv-a-small />
        </i>
        <i
          v-for="item in stv[numStars-1].stars"
          :key="'stvStar' + item"
          class="icon-v icon-stv-star"
        >
          <icon-stv-star />
        </i>
        <i
          v-if="stv[numStars-1].superior"
          class="icon-v icon-stv-superior"
        >
          <icon-stv-superior />
        </i>
      </template>
    </button>
  </div>
</template>

<script>
// import { VBPopover } from 'bootstrap-vue';
// import 'scss/bootstrap/vue/components/popover.scss';

/* ICONS */
import IconDtvLogoSmall from 'ICON:IconDtvLogoSmall';
import IconDtvStar from 'ICON:IconDtvStar';
import IconStvASmall from 'ICON:IconStvASmall';
import IconStvStar from 'ICON:IconStvStar';
import IconStvSuperior from 'ICON:IconStvSuperior';
import { modalLogic } from 'mixins/composition/PickerModal';

export default {
  name: 'StvDtvRating',
  // i18nOptions: { namespaces: ['object'] },
  // directives: { 'b-popover': VBPopover },
  components: {
    IconDtvLogoSmall,
    IconDtvStar,
    IconStvASmall,
    IconStvStar,
    IconStvSuperior,
  },
  props: {
    method: {
      required: true,
      type: String,
    },
    numStars: {
      required: true,
      type: Number,
    },
  },
  setup() {
    const { togglePreventScroll } = modalLogic();

    return { togglePreventScroll };
  },
  data() {
    return {
      stv: [ // STV awards (EDVUE-61)
        { stars: 1, superior: 0 }, //  1: einfach
        { stars: 1, superior: 1 }, //  2: einfach + superior
        { stars: 2, superior: 0 }, //  3: standard
        { stars: 2, superior: 1 }, //  4: standard + superior
        { stars: 3, superior: 0 }, //  5: komfort
        { stars: 3, superior: 1 }, //  6: komfort + superior
        { stars: 4, superior: 0 }, //  7: ersteKlasse
        { stars: 4, superior: 1 }, //  8: ersteKlasse + superior
        { stars: 5, superior: 0 }, //  9: luxus
        { stars: 5, superior: 1 }, // 10: luxus + superior
      ],
    };
  },
  methods: {
    async show() {
      const modal = await import(/* webpackChunkName: "stv-dtv-modal" */'components/StvDtvModal.vue');
      this.$modal.show(modal.default, {
        method: this.method,
      }, {
        name: 'stvdtv-modal',
        class: 'stvdtv-modal',
        height: 'auto',
        adaptive: true,
        scrollable: true,
      }, {
        'before-open': () => { this.togglePreventScroll(true); },
        'before-close': () => { this.togglePreventScroll(false); },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.rating-dtv-stv {
  cursor: pointer;
}

</style>
